export const AUTH_TOKEN_KEY = 'authToken'
export const USER_STORAGE_KEY = 'user'
export const CART_STORAGE_KEY = 'baterpower_cart'
export const CHECKOUT_STORAGE_KEY = 'baterpower_checkout_data'

export const USER_LOGOUT_EVENT = 'baterpower:userLoggedOut'

